import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

import styles from './agreement.module.scss';
import Checkbox from '../checkbox/checkbox';
import { emitEvent } from '../../event-emitter';
import { EVENT_CLICK_AGREEMENT } from '../../constants';

interface AgreementProps {
  onChange: (event:React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  checked: boolean;
}

export default function Agreement(props:AgreementProps) {
	const { onChange, name, checked } = props;
  const url = useSelector((state:RootState) => state.client?.privacyPolicy);
  
  const clickHandler = () => emitEvent(EVENT_CLICK_AGREEMENT);

	return (
		<span className={styles.agreement}>
			<input 
				name={name} 
				id='agreement'
				type='checkbox' 
				checked={checked}
				onChange={onChange}
			/>
			<label htmlFor='agreement'>
				<Checkbox kind='agreement' checked={checked}/>
				Согласен с&nbsp;
			</label>
			<a href={url} rel='noopener noreferrer' onClick={clickHandler} target='_blank'>политикой конфиденциальности</a>
		</span>
	);
}